import React, { useState } from "react";
import { Box, Typography, Avatar, Rating, Button } from "@mui/material";
import { ReviewDisplay } from "shared/types";

interface ReviewCardProps {
  review: ReviewDisplay;
}

const ReviewCard: React.FC<ReviewCardProps> = ({ review }) => {
  const [expanded, setExpanded] = useState(false);
  const MAX_LENGTH = 200;
  const needsTruncation = review.text.length > MAX_LENGTH;

  const displayText = expanded
    ? review.text
    : needsTruncation
      ? review.text.substring(0, MAX_LENGTH) + "..."
      : review.text;

  const displayDate =
    review.date instanceof Date
      ? review.date.toLocaleDateString()
      : review.date;

  return (
    <Box
      sx={{
        pb: 3,
        mb: 3,
        borderBottom: "1px solid #E0E0E0",
        "&:last-child": {
          borderBottom: "none",
        },
      }}
    >
      {/* Reviewer Info */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          mb: 2,
        }}
      >
        <Avatar
          src={review.reviewerPhotoUrl || undefined}
          alt={review.reviewerName}
          sx={{ width: 48, height: 48 }}
        >
          {review.reviewerName.charAt(0)}
        </Avatar>

        <Box sx={{ flex: 1 }}>
          <Typography variant="body2" sx={{ color: "#5A5A5A" }}>
            {displayDate}
          </Typography>
        </Box>

        <Rating
          value={review.rating}
          readOnly
          size="small"
          sx={{
            "& .MuiRating-iconFilled": {
              color: "#FFB400",
            },
          }}
        />
      </Box>

      {/* Review Text */}
      <Typography
        variant="body2"
        sx={{
          color: "#333",
          lineHeight: 1.7,
          mb: needsTruncation ? 1 : 0,
        }}
      >
        {displayText}
      </Typography>

      {/* Read More Button */}
      {needsTruncation && (
        <Button
          onClick={() => setExpanded(!expanded)}
          sx={{
            textTransform: "none",
            color: "#178B8E",
            fontWeight: 600,
            p: 0,
            minWidth: "auto",
            "&:hover": {
              backgroundColor: "transparent",
              textDecoration: "underline",
            },
          }}
        >
          {expanded ? "Show Less" : "Read More"}
        </Button>
      )}
    </Box>
  );
};

export default ReviewCard;
